import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/styles.scss";
import "./styles/mixins.scss";
import App from "./App.tsx";
import "@vkontakte/vkui/dist/vkui.css";
import { ctx } from "./core/reatom/ctx.ts";
import { reatomContext } from "@reatom/npm-react";
import {
  init,
  initData,
  isBackButtonMounted,
  miniApp,
  mountBackButton,
  showBackButton,
  swipeBehavior,
} from "@telegram-apps/sdk-react";
import { connectLogger } from "@reatom/framework";

init();

if (mountBackButton.isAvailable()) {
  mountBackButton();
  showBackButton();
  isBackButtonMounted();
}
if (miniApp.setHeaderColor.isAvailable()) {
  miniApp.setHeaderColor("#fff");
  miniApp.headerColor(); // 'bg_color'
}

initData.restore();
if (swipeBehavior.mount.isAvailable()) {
  swipeBehavior.mount();
  swipeBehavior.isMounted(); // true
}
if (swipeBehavior.disableVertical.isAvailable()) {
  swipeBehavior.disableVertical();
  swipeBehavior.isVerticalEnabled();
}

if (import.meta.env.DEV) {
  connectLogger(ctx);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <reatomContext.Provider value={ctx}>
      <App />
    </reatomContext.Provider>
  </StrictMode>
);
